export type PublicAssetType = "truck" | "trailer";

export interface PublicAssetDetails {
  unitNumber: string;
  year: string;
  vin: string;
  make: string;
  model: string;
  licensePlate: string;
}

export const isFolderId = (value?: string) =>
  !!value &&
  /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(value) &&
  value !== "00000000-0000-0000-0000-000000000000";

const detailKeys: (keyof PublicAssetDetails)[] = [
  "unitNumber",
  "year",
  "vin",
  "make",
  "model",
  "licensePlate",
];

// Only the fields intended for external visitors go into the URL fragment.
// These are a display snapshot, not a server-verified asset record.
export const createPublicAssetDocumentsUrl = (
  assetType: PublicAssetType,
  folderId: string,
  asset: Partial<Record<keyof PublicAssetDetails | "VIN", unknown>>,
) => {
  const details = new URLSearchParams();
  detailKeys.forEach((key) => {
    const value = key === "vin" ? (asset.vin ?? asset.VIN) : asset[key];
    if (value !== null && value !== undefined) details.set(key, String(value));
  });
  return `${window.location.origin}/unit-documents/${assetType}/${folderId}#${details.toString()}`;
};

export const readPublicAssetDetails = (hash: string): PublicAssetDetails => {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return Object.fromEntries(
    detailKeys.map((key) => [key, (params.get(key) ?? "").slice(0, 200)]),
  ) as unknown as PublicAssetDetails;
};
